import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLBoolean,
  GraphQLInt,
  GraphQLEnumType
} from 'graphql'

export interface SyslogFields {
  readonly ipAddress: string
  readonly port: number
  readonly facilityCode: number
  readonly protocol: SyslogProtocol
  readonly severityExploited: SyslogSeverity
  readonly severitySuspicious: SyslogSeverity
  readonly severityBlocked: SyslogSeverity
  readonly severityBlockedPerimeter: SyslogSeverity
  readonly severityProbed: SyslogSeverity
}

export interface SyslogConfig extends Partial<SyslogFields> {
  readonly enabled: boolean
}

export type SyslogProtocol = 'UDP' | 'TCP' | 'TCP_AND_TLS'

export type SyslogSeverity =
  | 'DEBUG'
  | 'NOTICE'
  | 'ALERT'
  | 'INFO'
  | 'CRITICAL'
  | 'ERROR'
  | 'WARNING'

export const syslogSeverityType = new GraphQLEnumType({
  name: 'SyslogSeverity',
  values: {
    DEBUG: {
      value: 'DEBUG'
    },
    NOTICE: {
      value: 'NOTICE'
    },
    ALERT: {
      value: 'ALERT'
    },
    INFO: {
      value: 'INFO'
    },
    CRITICAL: {
      value: 'CRITICAL'
    },
    ERROR: {
      value: 'ERROR'
    },
    WARNING: {
      value: 'WARNING'
    }
  }
})

export const syslogProtocolType = new GraphQLEnumType({
  name: 'SyslogProtocol',
  values: {
    UDP: { value: 'UDP' },
    TCP: { value: 'TCP' },
    TCP_AND_TLS: { value: 'TCP_AND_TLS' }
  }
})

export const syslogConfig = new GraphQLObjectType({
  name: 'SyslogConfig',
  fields: () => ({
    enabled: {
      description: 'Is Syslog enabled',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    ipAddress: {
      description: 'The address of the Syslog server',
      type: GraphQLString
    },
    port: {
      description: '',
      type: GraphQLInt
    },
    facilityCode: {
      description: '',
      type: GraphQLInt
    },
    protocol: {
      description: '',
      type: syslogProtocolType
    },
    severityExploited: {
      description: '',
      type: syslogSeverityType
    },
    severitySuspicious: {
      description: '',
      type: syslogSeverityType
    },
    severityBlocked: {
      description: '',
      type: syslogSeverityType
    },
    severityBlockedPerimeter: {
      description: '',
      type: syslogSeverityType
    },
    severityProbed: {
      description: '',
      type: syslogSeverityType
    }
  })
})
